/**
 * en-GB messages added by Phase 4 task S45B (docs/PHASE-4-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 */
export const s45bEnGB = {
    'preregistration.form.host_given': 'Host given on the form: {name}',
    'preregistration.form.thanks_default': 'Thank you. Your visit has been registered.',
    'error.form_field_not_allowed': 'That question cannot be used on a public form.',
    'error.form_slug_taken': 'Another form already uses that address.',
    'error.form_consent_required': 'Please tick the box to agree.',
    'error.form_date_range': 'Choose a date and time from now until the latest date this form allows.',
    'error.form_email_required': 'Please enter an email address.',
    'error.form_phone_required': 'Please enter a phone number.',
    'error.form_company_required': 'Please enter your company.',
    'error.form_host_required': 'Please enter the name of the person you are visiting.',
    'settings.pre-registration.formDailyCap': 'Most submissions one public form accepts per day (0 = no limit)',
    'settings.pre-registration.formEmailsPerAddressPerDay': 'Most public-form submissions per email address per day, across all forms (0 = no limit)',
};
//# sourceMappingURL=s45b.js.map